import { useAuth } from '@invara-dev/react-base';
import { FrontierUser } from '../../globalModels/frontierUser';

export const useFrontierAuth = () => {
  return useAuth<FrontierUser>();
};
